<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_160_22)">
<path d="M85.1848 24.8362L37.5631 82.3528L37.8173 52.1838L11.5631 37.3195L85.1848 24.8362Z" stroke="black" stroke-width="4"/>
<path d="M82.7133 26.5669L37.68 52.5669" stroke="black" stroke-width="4"/>
</g>
<defs>
<clipPath id="clip0_160_22">
<rect width="100" height="100" fill="white"/>
</clipPath>
</defs>
</svg>

</template>
